import { CustomerDocument } from 'generated-api/bff/api';
import { formatDate } from './DatesUtil';
import { FormattedCustomerDocument, TitleReplaceEnum } from './MessagesServicesTypes';

export const formatMessage = (documents: CustomerDocument[]): FormattedCustomerDocument[] => {
	if (!documents?.length) return [];

	const formattedDocuments: FormattedCustomerDocument[] = documents.map((document) => {
		const formattedDate = formatDate(document.date);
		const dateMinusDot = formattedDate.replace(/\./g, '');
		const formattedDoc: FormattedCustomerDocument = {
			...document,
			formattedDate,
			dateMinusDot,
			description: formatDescription(document?.description),
			doc_type: formatDocType(document.doc_type),
		};
		return optimizeDocumentOnSmallScreens(formattedDoc);
	});

	return formattedDocuments;
};

const formatDescription = (description: string): string => {
	if (description === undefined) return '';

	if (description.length >= 1 && description.length <= 3) return TitleReplaceEnum['Volapyk'];

	return description;
};

const formatDocType = (doc_type: string) => {
	if (doc_type.length >= 1 && doc_type.length <= 3) return TitleReplaceEnum['Volapyk'];

	const matchValue = TitleReplaceEnum[doc_type as keyof typeof TitleReplaceEnum];
	if (matchValue !== null && matchValue !== undefined) return matchValue;

	return doc_type;
};

const optimizeDocumentOnSmallScreens = (document: FormattedCustomerDocument): FormattedCustomerDocument => {
	if (screen.width > 320) return document;

	if (document.name !== '' && document.name.length > 17) {
		document.name = document.name.substring(0, 17) + '...';
	}
	if (document.description !== '' && document.description.length > 25) {
		document.description = document.description.substring(0, 25) + '...';
	}
	return document;
};
